import { List, Typography } from 'antd';

const { Text } = Typography;

const NonReturnedAndOnTimeCompleteCollection = () => {

  const data = [
    'Bir sipariş zamanında toplanmasına rağmen içerisinde poşet hariç en az 1 ürün iptal edilmiş veya tam toplansa da iadeli teslim edilmiş ise bu KPI için osipariş başarısız sayılır.',
    'Bir siparişin tüm ürünleri toplanıp eksiksiz teslim edilmesine rağmen zamanında toplanmamış ise bu KPI için o sipariş başarısız sayılır.',
    'Normal şartlarda teslim edilen siparişler orana yansır ancak teslimata kadar siparişin başarısız olduğu kesinleşmiş ise doğrudan oranı etkiler.',
    'Sipariş teslim edilirken başarılı olmasına rağmen sonraki günlerde marketten iade girilir ise ilgili aya ait oranı olumsuz olarak etkiler.',
    'Siparişin tümü iptal edilmiş ise buraya yansımaz.',
    'Günlük performansta 00:00’dan itibaren bakılan ana kadar işlem gören ve görmesi gereken siparişler üzerinden oran gösterilir.',
    'Aylık performansta ilgili ayın 1’inden itibaren o ana kadar olan siparişler üzerinden oran gösterilir'
  ];

  return (<List
    className="demo-loadmore-list"
    itemLayout="horizontal"
    dataSource={data}
  >
    <List.Item.Meta
      style={{ marginBottom: 10 }}
      title={
        <Text strong style={{ fontSize: 16 }}>
          İlgili dağıtım tarihine ait siparişlerin ne kadarının zamanında ve tam toplanıp,
          iadesiz teslim edildiğini gösteren orandır.
        </Text>
      }
    />
    <ul>
      {data.map((item, index) => (<li style={{ color: '#555555', fontWeight: 500 }} key={index}>{item}</li>))}
    </ul>
  </List>);
};

export default NonReturnedAndOnTimeCompleteCollection;
